module.exports = __webpack_public_path__ + "img/hasenov_500.62a94efb.jpg";